import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            dark: {
                primary: "#000000",
                secondary: "#e30000",
                accent: "#eaf2f7",
                info: "#7c7c7c",
                shop: "##ca2828"
            },
            light: {
                primary: "#000000",
                secondary: "#e30000",
                accent: "#eaf2f7",
                info: "#7c7c7c",
                shop: "#ca2828"
            }
        }
    },
    breakpoint: {
    thresholds: {
      xs: 415,
      sm: 736,
      md: 1080,
      lg: 1920,
      xl: 4000,
    },
}
});
